module.exports = __webpack_public_path__ + "media/images/lms/moodle-3a1428db96f43fd882662b3222ef7afd.png";